import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=47a6eb3a&scoped=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=js"
export * from "./AddProjectModal.vue?vue&type=script&lang=js"
import style0 from "./AddProjectModal.vue?vue&type=style&index=0&id=47a6eb3a&prod&lang=scss"
import style1 from "./AddProjectModal.vue?vue&type=style&index=1&id=47a6eb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6eb3a",
  null
  
)

export default component.exports